export default __webpack_public_path__ + "static/media/Logo_gestify_sobrenegro.6e3445df.png";